<template>
    <div>
        <div>
            <b-sidebar id="sidebar-backdrop" class="sidebar-recurring-schedule" :backdrop-variant="'dark'" :title="$t('addRecurringSched.title')" backdrop shadow
                :visible="allowAddRecurringSchedule" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
                <div class="d-block text-center mt-3">
                    <b-row class="align-items-center px-4" v-if="stepper === 1">
                        <b-col sm="12">
                            <div class="text-left">
                                <b-form-group :label="$t('addRecurringSched.descriptionLabel')" class="text-left">
                                    <b-form-input type="text" :placeholder="$t('addRecurringSched.descriptionPlaceholder')" required
                                        v-model="recurringSchedulePayload.description"></b-form-input>
                                    <p v-if="errors && errors.description" class="field-error">
                                        {{ errors.description[0] }}
                                    </p>
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col sm="12">
                            <div class="text-left select_row">
                                <label class="state">{{ $t('addRecurringSched.intervalLabel') }}</label>
                                <b-form-select class="f-14" v-model="recurringSchedulePayload.interval_type" :options="intervalOptions" />
                                <p v-if="errors && errors.interval_type" class="field-error">
                                    {{ errors.interval_type[0] }}
                                </p>
                            </div>
                        </b-col>
                        <b-col sm="12" v-if="recurringSchedulePayload.interval_type">
                            <div class="text-left mt-3">
                                <b-form-group
                                    :label="recurringSchedulePayload.interval_type === '2' ? $t('addRecurringSched.milesInterval') : $t('addRecurringSched.daysInterval')"
                                    class="text-left">
                                    <b-form-input type="number"
                                        :placeholder="recurringSchedulePayload.interval_type === '2' ? $t('addRecurringSched.milesIntervalPlaceholder') : $t('addRecurringSched.daysIntervalPlaceholder')"
                                        required v-model="recurringSchedulePayload.interval"></b-form-input>
                                    <p v-if="errors && errors.interval" class="field-error">
                                        {{ errors.interval[0] }}
                                    </p>
                                </b-form-group>
                            </div>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <b-row class="align-items-center px-4">
                            <!-- Tags parked for now: the unit picker below covers picking
                                 units, so this is hidden rather than removed. -->
                            <!-- <b-col sm="12">
                                <div class="text-left select_arrow ">
                                    <label class="state">{{ $t('addRecurringSched.tagsLabel') }}</label>
                                    <v-select class="bg_white w-100" multiple v-model="recurringSchedulePayload.tags"
                                        :options="allTags" item-value="id" item-text="label"
                                        :reduce="(option) => option.id">

                                    </v-select>
                                    <p v-if="errors && errors.unit_no" class="field-error">
                                        {{ errors.unit_no[0] }}
                                    </p>
                                </div>
                            </b-col> -->
                            <b-col sm="12">
                                <div class="text-left mt-3">
                                    <label class="state">{{ $t('addRecurringSched.unitsLabel') }}</label>
                                    <b-input-group class="username-input-field mb-2">
                                        <b-form-input v-model="unitSearch" class="unit f-12"
                                            :placeholder="$t('addRecurringSched.searchUnit')"
                                            @keyup.enter="reloadUnits" />
                                        <b-input-group-append>
                                            <b-button variant="primary" @click="reloadUnits">
                                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                        stroke="white" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <div class="d-flex flex-wrap mb-2">
                                        <b-button v-for="option in unitTypeFilters" :key="option.value" size="sm"
                                            class="mr-2 f-12"
                                            :variant="unitTypeFilter === option.value ? 'primary' : 'outline-primary'"
                                            @click="setUnitType(option.value)">
                                            {{ option.text }}
                                        </b-button>
                                    </div>
                                    <!-- Scrolls to the end to pull the next page. -->
                                    <div class="unit-picker" @scroll="onUnitsScroll">
                                        <div class="unit-row d-flex align-items-center" v-for="unit in visibleUnits"
                                            :key="unit.id">
                                            <b-form-checkbox class="mr-2 pl-0"
                                                :checked="isAdded(unit.id)"
                                                @change="toggleUnit(unit.id)" />
                                            <span class="f-14 font-weight-bold text-black mr-2">{{ unit.label }}</span>
                                            <span class="unit-type-chip f-12" v-if="unit.type">{{ unit.type }}</span>
                                            <span class="ml-auto f-12 text-grey">{{ unit.odometer.toLocaleString() }}</span>
                                        </div>
                                        <p class="f-12 text-grey text-center mb-0 p-3" v-if="unitsLoading">
                                            {{ $t('addRecurringSched.loadingUnits') }}
                                        </p>
                                        <p class="f-12 text-grey text-center mb-0 p-3"
                                            v-else-if="!visibleUnits.length">
                                            {{ $t('addRecurringSched.noUnitsFound') }}
                                        </p>
                                    </div>
                                    <div class="d-flex align-items-center mt-2">
                                        <b-button variant="outline-primary" size="sm" class="f-12"
                                            :disabled="!addableUnits.length" @click="addAllShown">
                                            {{ $t('addRecurringSched.addAllShown', { count: addableUnits.length }) }}
                                        </b-button>
                                        <span class="ml-auto f-12 text-grey">
                                            {{ $t('addRecurringSched.unitsShown', { shown: visibleUnits.length, total: unitsTotal }) }}
                                        </span>
                                    </div>
                                </div>
                                <hr class="my-4" />
                            </b-col>
                            <b-col sm="12">
                                <h3 class="f-18 font-weight-bold text-left mb-3">{{ $t('addRecurringSched.unitsCount', { count: availableUnits.length }) }}</h3>
                            </b-col>
                        </b-row>
                        <div class="recurring-schedule-table mb-7rem">
                            <b-table responsive sticky-header="360px" :fields="translatedFields" :items="items" hover
                                :current-page="currentPage" show-empty>
                                <template #cell(next_service)="data">
                                    <b-form-input v-if="recurringSchedulePayload.interval_type === '2'" v-model="data.item.next_service"
                                        class="w-50" />
                                    <b-form-input type="date" v-else v-model="data.item.date" class="w-50"/>
                                </template>
                                <template #cell(action)="data">
                                    <svg @click="deleteTableItem(data.item.id)" class="cursor-pointer" width="19"
                                        height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
                <div class="sidebar-footer position-fixed">
                    <div class="d-flex align-items-center justify-content-end">
                        <div class="text-right modal-footer border-0 p-0">
                            <b-button class="mx-0 mr-3 h-40px w-100px m-0" @click="resetPopup()"
                                variant="secondary">{{ $t('maintenanceShared.cancel') }}</b-button>
                            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                                @click="addRecurringSchedule()">{{ stepper === 1 ? $t('maintenanceShared.next') : $t('maintenanceShared.save') }}</b-button>
                        </div>
                    </div>
                </div>
            </b-sidebar>
        </div>
    </div>
</template>
<script>
// Both parked with the tags select above; restore together.
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";
export default {
    name: "AddRecurringSchedule",
    components: {},
    data() {
        return {
            stepper: 1,
            currentPage: 1,
            items: [],
            equipOptions: [],
            availableUnits: [],
            unitSearch: "",
            unitTypeFilter: "",
            unitRows: [],
            unitsPage: 1,
            unitsTotalPages: 1,
            unitsTotal: 0,
            unitsLoading: false,
            recurringSchedulePayload: {
                description: "",
                interval_type: "",
                interval: "",
                tags: []
            },
            errors: {},
        }
    },
    props: {
        allowAddRecurringSchedule: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters([
            "userCompany",
            "tags"
        ]),
        intervalOptions() {
            return [
                { value: '', text: '' },
                { value: '2', text: this.$t('addRecurringSched.intervalMiles') },
                { value: '1', text: this.$t('addRecurringSched.intervalDays') },
            ];
        },
        translatedFields() {
            if (this.recurringSchedulePayload.interval_type === '2') {
                return [
                    { label: this.$t('addRecurringSched.columnUnitNo'), key: "unit_no", sortable: true, thClass: 'font-table-weight-bold' },
                    { label: this.$t('addRecurringSched.columnCurrentMi'), key: "current_mi", sortable: true, thClass: 'font-table-weight-bold' },
                    { key: "next_service", label: this.$t('addRecurringSched.columnNextService'), sortable: true, thClass: 'font-table-weight-bold' },
                    { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
                ]
            }
            return [
                { label: this.$t('addRecurringSched.columnUnitNo'), key: "unit_no", sortable: true, thClass: 'font-table-weight-bold' },
                { key: "next_service", label: this.$t('addRecurringSched.columnNextService'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ]
        },
        // Everything loaded stays on screen — units already on the schedule show as
        // ticked rather than vanishing, so the list keeps its height and scrolling
        // still reaches the next page.
        visibleUnits() {
            return this.unitRows;
        },
        // The ones still worth adding: what Add all works on.
        addableUnits() {
            return this.unitRows.filter((unit) => !this.isAdded(unit.id));
        },
        unitTypeFilters() {
            return [
                { value: "", text: this.$t("addRecurringSched.filterAll") },
                { value: "Vehicle", text: this.$t("documentsPage.typeVehicle") },
                { value: "Trailer", text: this.$t("documentsPage.typeTrailer") },
            ];
        },
        allTags() {
            return this.tags.map((item) => {
                return {
                    id: item.id,
                    label: item.add_tag,
                }
            })
        }
    },
    watch: {
        availableUnits: {
            handler() {
                if (this.availableUnits.length) {
                    const data = this.availableUnits.map(id => {
                        const foundItem = this.equipOptions.find(item => item.id === id);
                        if (foundItem) {
                            return foundItem
                        }
                    });
                    data.map((item) => {
                        if(this.items.filter((data)=>data.id === item.id).length === 0){
                        this.items.push({
                            unit_no: item.label,
                            id: item.id,
                            current_mi: item.odometer.toLocaleString(),
                            next_service: this.recurringSchedulePayload.interval_type === '2' ? Number(item.odometer) + Number(this.recurringSchedulePayload.interval) : moment().add(this.recurringSchedulePayload.interval, 'days').format("ll"),
                            date: moment().add(this.recurringSchedulePayload.interval, 'days').format("YYYY-MM-DD")
                        })
                    }
                    })
                } else this.items = []
            },
            deep: true
        },
        async allowAddRecurringSchedule() {
            if (this.allowAddRecurringSchedule) {
                await this.getAllTags(this.userCompany);
                this.loadUnits(true);
            }
        },
        recurringSchedulePayload: {
            async handler() {
                if (this.recurringSchedulePayload.tags.length) {
                    let options = []
                    this.equipOptions = [...this.equipOptions.filter(item => this.availableUnits.includes(item.id))]
                    const equipTags = this.recurringSchedulePayload.tags.map(id => {
                        const foundItem = this.tags.find(item => item.id === id);
                        if (foundItem) {
                            return foundItem.add_tag
                        }
                    });
                    let url = `tags=${equipTags.toString()}&sort_field=unit_no&sort_order=asc&page=1&page_size=25`
                    try {
                        this.setLoader(true)
                        const equipmentRecords = await this.getAllEquipments(url);
                        equipmentRecords.records.map((item) => {
                            options.push({
                                id: `${item.id}`,
                                label: item.unit_no,
                                odometer: item.current_odometer ? item.current_odometer : 0,
                                type: "equipment",
                            });
                        });
                        this.equipOptions = [...options, ...this.equipOptions]
                        this.equipOptions = [...new Map(this.equipOptions.map(item => [item['id'], item])).values()]
                        this.availableUnits = Array.from(
                        new Set([
                            ...this.availableUnits,
                            ...this.equipOptions.map(item => item.id)
                        ]))
                        this.setLoader(false)
                    }
                    catch (e) {
                        this.setLoader(false)
                    }
                }
            },
            deep: true,
        }
    },
    methods: {
        ...mapActions(['getAllTags', "getFilteredEquipments", "setLoader", "setNotification", 'addRecurringScheduleData', 'getAllEquipments']),
        // Only offer units that are not on the schedule yet, so the list stays
        // short. Done with the filter prop rather than by trimming :options,
        // because vue-select resolves the chips' labels from the full list.
        // One page of equipment at a time; reset starts the list over after a
        // search or a type change, otherwise it appends the next page.
        async loadUnits(reset = false) {
            if (this.unitsLoading) return;
            const page = reset ? 1 : this.unitsPage;
            if (!reset && page > this.unitsTotalPages) return;
            this.unitsLoading = true;
            try {
                const search = this.unitSearch.trim();
                let url = `status=Active,Assigned&sort_field=unit_no&sort_order=asc&page=${page}&page_size=25`;
                if (search) url += `&unit_no=${encodeURIComponent(search)}`;
                if (this.unitTypeFilter) url += `&type=${this.unitTypeFilter}`;
                const data = await this.getAllEquipments(url);
                const rows = (data.records || []).map((item) => ({
                    id: `${item.id}`,
                    label: item.unit_no,
                    odometer: item.current_odometer ? item.current_odometer : 0,
                    type: item.type,
                }));
                this.unitRows = reset ? rows : [...this.unitRows, ...rows];
                // Ids can arrive twice when a page boundary shifts between calls.
                this.unitRows = [...new Map(this.unitRows.map((row) => [row.id, row])).values()];
                this.unitsTotalPages = data.total_pages || 1;
                this.unitsTotal = data.total_entries || this.unitRows.length;
                this.unitsPage = page + 1;
            } catch (e) {
                console.log(e);
            } finally {
                this.unitsLoading = false;
            }
        },
        reloadUnits() {
            this.loadUnits(true);
        },
        setUnitType(type) {
            if (this.unitTypeFilter === type) return;
            this.unitTypeFilter = type;
            this.reloadUnits();
        },
        onUnitsScroll(event) {
            const { scrollTop, clientHeight, scrollHeight } = event.target;
            // Removing rows (adding units) shortens the list, the browser re-clamps
            // scrollTop and that fires scroll too — which used to read as "at the
            // bottom" and pull another page. Only page when the user actually
            // scrolled a list that overflows.
            if (scrollHeight <= clientHeight || scrollTop <= 0) return;
            if (scrollTop + clientHeight >= scrollHeight - 40) this.loadUnits();
        },
        isAdded(id) {
            return this.availableUnits.map((added) => `${added}`).includes(`${id}`);
        },
        // The checkbox is the schedule itself: ticking adds the unit, unticking
        // takes it back off — same as the delete icon in the table below.
        toggleUnit(id) {
            if (this.isAdded(id)) this.removeUnit(id);
            else this.addUnits([id]);
        },
        removeUnit(id) {
            this.availableUnits = this.availableUnits.filter((added) => `${added}` !== `${id}`);
            this.items = this.items.filter((item) => `${item.id}` !== `${id}`);
        },
        // Adding is just putting ids into availableUnits — the watcher below builds
        // the schedule rows from equipOptions, so the picked units go in there too.
        addUnits(ids) {
            if (!ids.length) return;
            const picked = this.unitRows.filter((unit) => ids.includes(unit.id));
            this.equipOptions = [
                ...new Map([...this.equipOptions, ...picked].map((item) => [item.id, item])).values(),
            ];
            this.availableUnits = [...new Set([...this.availableUnits, ...ids])];
        },
        // Adds only what is on screen — no fetching here; the next page arrives
        // when the list is scrolled, and appends to what is already loaded.
        addAllShown() {
            this.addUnits(this.addableUnits.map((unit) => unit.id));
        },
        deleteTableItem(id) {
            this.availableUnits = this.availableUnits.filter((item) => item !== id)
            this.items = this.items.filter((item)=>item.id !==id)
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
       async searchAssets(searchText) {
            if (searchText) {
                let options = []
                let url = `unit_no=${searchText}&sort_field=unit_no&sort_order=asc&page=1&page_size=25`
                try {
                    const equipmentRecords = await this.getAllEquipments(url);
                    equipmentRecords.records.map((item) => {
                        options.push({
                            id: item.id,
                            label: item.unit_no,
                            odometer: item.current_odometer ? item.current_odometer : 0
                        });
                    });
                    this.equipOptions = [...options, ...this.equipOptions]
                    this.equipOptions = [...new Map(this.equipOptions.map(item => [item['id'], item])).values()]
                }
                catch (e) {
                    console.log(e)
                }
            }
        },
        async addRecurringSchedule() {
            if (this.stepper === 1) {
                try {
                    const nullKeys = this.checkNullValues({
                        description: this.recurringSchedulePayload.description,
                        interval: this.recurringSchedulePayload.interval,
                        interval_type: this.recurringSchedulePayload.interval_type
                    });
                    if (nullKeys.length === 0) {
                        this.stepper++;
                    }
                    else {
                        let error = {};
                        nullKeys.forEach((x) => {
                            error[x] = [this.$t('maintenanceShared.fieldRequired')];
                        });
                        throw error;
                    }
                }
                catch (error) {
                    if (typeof error === "object") {
                        this.errors = error;
                    }
                }
            }
            else {
                if (this.availableUnits.length) {
                    try {
                        this.setLoader(true)
                        const payload = {
                            description: this.recurringSchedulePayload.description,
                            interval_type: this.recurringSchedulePayload.interval_type,
                            company: this.userCompany,
                            units: this.items.map((item) => {
                                return {
                                    "unit_no": item.id,
                                    ...this.recurringSchedulePayload.interval_type === '2' ? { "next_service_mile": item.next_service } : { "next_service_date": moment(item.date).format("YYYY-MM-DD") }
                                }
                            }),
                            ...this.recurringSchedulePayload.interval_type === '2' ? { interval_miles: this.recurringSchedulePayload.interval } : { interval_days: this.recurringSchedulePayload.interval }
                        }
                        await this.addRecurringScheduleData(payload)
                        await this.setNotification({
                            msg: this.$t('addRecurringSched.addedSuccess'),
                            type: "success",
                            color: "green",
                        });
                        this.setLoader(false)
                        this.$emit("recordAdded")
                        this.resetPopup()
                    }
                    catch (e) {
                        console.log(e)
                        this.setLoader(false)
                    }
                } else {
                    await this.setNotification({
                        msg: this.$t('addRecurringSched.unitsRequired'),
                        type: "error",
                        color: "red",
                    });
                }
            }
        },
        resetPopup() {
            this.stepper = 1
            this.recurringSchedulePayload = {
                description: "",
                interval_type: "",
                interval: "",
                tags: []
            }
            this.errors = {}
            this.items = []
            this.equipOptions= [],
            this.availableUnits= [],
            this.unitSearch = ""
            this.unitTypeFilter = ""
            this.unitRows = []
            this.unitsPage = 1
            this.unitsTotalPages = 1
            this.unitsTotal = 0
            this.$emit('close');
        },
    },
}
</script>
<style>
.unit-picker {
    max-height: 280px;
    overflow-y: auto;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
}

.unit-row {
    padding: 8px 12px;
    border-bottom: 1px solid #f2f2f2;
}

.unit-row:last-child {
    border-bottom: none;
}

.unit-type-chip {
    padding: 2px 8px;
    border-radius: 4px;
    background-color: rgba(45, 105, 246, 0.1);
    color: #2d69f6;
}

.mh-40px .vs__dropdown-toggle {
    min-height: 40px !important;
}

/* .recurring-schedule-table .table-responsive{
    height: 350px;
} */
</style>